import React from 'react';
import MainGridTopLeft from './MainGridTopLeft';
import MainGridTopRightDayOffTypePachi from './MainGridTopRightDayOffTypePachi';

/**
 * MainGridError
 */
class MainGridError extends React.Component {

  componentDidMount() {
    $('#ledger_sheet_01').flexLedgerSheet();
  }

  render() {
    return (
      <div id="ledger_sheet_01" className="wrap_ledger_sheet limit_col_width grid1">
        <div className="ledger_sheet_top grid_sheet_top">
          <MainGridTopLeft />
          <MainGridTopRightDayOffTypePachi actions={this.props.actions}  />
        </div>
      </div>
    );
  }
}

export default MainGridError;
